export const convertBase64ToHtmlImage = (base64: string): Promise<HTMLImageElement> => {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous'; // Garante que imagens externas funcionem corretamente
    image.onload = () => resolve(image);
    image.onerror = () => reject('Erro ao carregar a imagem');
    image.src = base64;
  });
};
